import React from "react";
import {
  Box,
  Button,
  Collapse,
  Grid,
  IconButton,
  Paper,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import { DatePicker } from "@mui/x-date-pickers";
import { motion } from "framer-motion";
import {
  Close as CloseIcon,
  Download as DownloadIcon,
  FilterList as FilterListIcon,
  Refresh as RefreshIcon,
} from "@mui/icons-material";

const AMBER = "#d97706";
const AMBER_LIGHT = "#f59e0b";

const SimpleLabelFilters = ({
  filters,
  filterOpen,
  handleFilterChange,
  resetFilters,
  toggleFilters,
  applyFilters,
  refreshData,
  exportExcel,
}) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.2, duration: 0.5 }}
    >
      <Paper
        elevation={0}
        sx={{
          p: 2,
          mb: 4,
          borderRadius: 3,
          background: `linear-gradient(135deg, ${alpha(AMBER, 0.02)} 0%, ${alpha(AMBER_LIGHT, 0.05)} 100%)`,
          border: `1px solid ${alpha(AMBER, 0.1)}`,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Typography variant="h6" component="h2" fontWeight={600}>
            Filtros
          </Typography>
          <Box>
            <Tooltip title="Filtros">
              <IconButton onClick={toggleFilters} sx={{ color: AMBER }}>
                <FilterListIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Recarregar">
              <IconButton onClick={refreshData} sx={{ color: AMBER }}>
                <RefreshIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Baixar Excel">
              <IconButton onClick={exportExcel} sx={{ color: AMBER }}>
                <DownloadIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>

        <Collapse in={filterOpen}>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12} sm={6} md={4}>
              <TextField
                fullWidth
                label="Nome do Produto"
                variant="outlined"
                size="small"
                value={filters.productName}
                onChange={(e) =>
                  handleFilterChange("productName", e.target.value)
                }
                placeholder="Digite o nome do produto..."
                sx={{
                  "& .MuiOutlinedInput-root": {
                    "&:hover fieldset": { borderColor: alpha(AMBER, 0.4) },
                    "&.Mui-focused fieldset": { borderColor: AMBER },
                  },
                  "& .MuiInputLabel-root.Mui-focused": { color: AMBER },
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <DatePicker
                label="Data Inicial"
                value={filters.startDate}
                onChange={(date) => handleFilterChange("startDate", date)}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    size: "small",
                    variant: "outlined",
                  },
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4}>
              <DatePicker
                label="Data Final"
                value={filters.endDate}
                onChange={(date) => handleFilterChange("endDate", date)}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    size: "small",
                    variant: "outlined",
                  },
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
                <Button
                  variant="outlined"
                  onClick={resetFilters}
                  startIcon={<CloseIcon />}
                  sx={{
                    borderColor: alpha(AMBER, 0.3),
                    color: AMBER,
                    "&:hover": {
                      borderColor: AMBER,
                      backgroundColor: alpha(AMBER, 0.04),
                    },
                  }}
                >
                  Limpar
                </Button>
                <Button
                  variant="contained"
                  onClick={applyFilters}
                  startIcon={<FilterListIcon />}
                  sx={{
                    background: `linear-gradient(135deg, ${AMBER} 0%, ${AMBER_LIGHT} 100%)`,
                    boxShadow: `0 4px 12px ${alpha(AMBER, 0.3)}`,
                    "&:hover": {
                      boxShadow: `0 6px 20px ${alpha(AMBER, 0.4)}`,
                    },
                  }}
                >
                  Aplicar
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Collapse>
      </Paper>
    </motion.div>
  );
};

export default SimpleLabelFilters;
